import { Injectable } from '@angular/core';
import {HttpClient} from "@angular/common/http";
import {Observable} from "rxjs";
import {environment} from "../../../../environments/environment";
import {VehicleDto} from "../../../auto-generated-server-dtos/warranty-search/vehicle-dto";

@Injectable({
  providedIn: 'root'
})
export class WarrantySearchService {

  constructor(private httpClient: HttpClient) { }

  WarrantySearch(warrantyId: string): Observable<VehicleDto[]> {
    return this.httpClient.get<VehicleDto[]>(`${environment.apiServer}/WarrantySearch`, {params: {warrantyId: warrantyId}});
  }
}
